import React, { useEffect, useState, useContext, useRef } from 'react'
import { Grid, GridColumn as Column, GridNoRecords, GridToolbar } from '@progress/kendo-react-grid';
import { ExcelExport } from '@progress/kendo-react-excel-export';
import './wizard.css'
// * Helpers
import Notifications, { ERROR_NOTIFICATION } from '../../helpers/notifications';
import { useTranslation } from 'react-i18next';
import API from "../../services/api";
// Context
import AuthContext from '../../context/Auth/AuthContext';
import { VIEW } from '../../assets/Constants/actionsTypes';

/*List of icons used in this component*/
/**Important: to see the full icons list visit: https://react-icons.github.io/react-icons */
import { ImArrowRight, ImArrowLeft } from 'react-icons/im'

const Step9 = (props) => {
    // * we call the hook to make translations
    const { t } = useTranslation('common');
    // list of data
    const [gridDataList, setGridDataList] = useState([])
    // user information from context
    const { user } = useContext(AuthContext);
    //
    const _export = useRef(null);

    // * This function is called when the PREVIOUS arrow is clicked.
    // * It is passed as parameter to each step 
    const onPreviousClick = () => {
        props.changeStep(6);
    }

    // * This function is called when the NEXT arrow is clicked.
    // * It is passed as parameter to each step 
    const onNextClick = () => {
        props.changeStep(8);
    }

    // we use useEffect to call the function that returns the step1 data
    useEffect(() => {
        if (props.activeStep === 7) {
            getStep9Data();
        }
    }, [props.activeStep]); // eslint-disable-line react-hooks/exhaustive-deps

    const getStep9Data = async () => {
        try {
            // data to be sent
            let dataSent = {
                UserCode: user.email,
                ModelId: props.modelData.modelid,
                BenefitId: null,
                SPFunctionId: null,
                SPComponentId: null,
                minCreationYear: null,
                MaxCreationYear: null,
                GroupName: null,
                AdminInstitutionName: null,
                LegalFramework: null,
                Description: null,
                PolicyGaps: null,
                Issues: null,
                Recommendations: null,
                Annotations: null
            }

            // gets data from API
            const response = await API.post('/model/getAssessmentMatrix', dataSent);
            // if error in request
            if (response.data.code !== 100) {
                Notifications.notify(response.data.msg, ERROR_NOTIFICATION);
                return;
            } else {
                setGridDataList(response.data.data);
            }
        } catch (e) {
            Notifications.notify(String(e), ERROR_NOTIFICATION);
            console.log(e)
        }
    }

    // Action triggered in Excel export button
    const excelExport = () => {

        if (gridDataList === [] || gridDataList === null || gridDataList.length <= 0) {
            Notifications.notify(t(`model.noExcelData`), ERROR_NOTIFICATION);
            return;
        } else {
            if (_export.current !== null) {
                _export.current.save();
            }
        }
    };

    return (
        <div className="col-md-12">
            <div className="row">
                <h6>{t('model.step9_desc')}</h6>
            </div>
            <div className="row row_attrs container_steps">
                <div className="col-sm-12" style={{ textAlign: "center" }}>
                    <ExcelExport data={gridDataList} ref={_export} fileName={props.modelData.code ? 'Matrix_Assesment_' + props.modelData.code : 'Assessment_Step9'}>
                        <Grid style={{ height: '100%' }} data={gridDataList} resizable={true}>
                            {/* this is the message when there are no records */}
                            <GridNoRecords>{t('grids.no_records')}</GridNoRecords>
                            <GridToolbar>
                                <button
                                    className="btn btn-primary ilo-btn"
                                    style={{ marginBottom: "10px", marginRight: "3px" }}
                                    onClick={excelExport}>
                                    {t('model.excelExport_btn')}
                                </button>
                            </GridToolbar>
                            {/* columns of the grid */}
                            <Column field="benefitName" title={t('model.step9_benefitName')} width="200" />
                            <Column title={t('model.step9_mainCharac')}>
                                <Column field="spFunctionName" title={t('model.step9_spFunctionName')} width="200" />
                                <Column field="spComponentName" title={t('model.step9_spComponentName')} width="220" />
                                <Column field="popGroupsCSV" title={t('model.step9_popGroupsCSV')} width="200" />
                            </Column>
                            <Column title={t('model.step9_legFram')} >
                                <Column field="legalFramework" title={t('model.step9_legBase')} width="200" />
                                <Column field="creationYear" title={t('model.step9_creationYear')} width="200" />
                                <Column field="adminInstitutionName" title={t('model.step9_adminInstitutionName')} width="200" />
                            </Column>
                            <Column field="description" title={t('model.step9_description')} width="200" />
                            <Column field="policyGaps" title={t('model.step9_policyGaps')} width="200" />
                            <Column field="implementationIssues" title={t('model.step9_implementationIssues')} width="200" />
                            <Column field="recommendations" title={t('model.step9_recommendations')} width="200" />
                            <Column field="annotations" title={t('model.step9_annotations')} width="200" />
                        </Grid>
                    </ExcelExport>
                </div>
            </div>
            <div className="row arrows_position">
                <div className="col-sm-12">
                    <button className="btn_style" type="button" onClick={() => { onPreviousClick(); }} ><ImArrowLeft /></button>
                    <button className="btn_style" type="button" onClick={() => { onNextClick(); }} ><ImArrowRight /></button>
                </div>
            </div>
        </div>
    );
}

export default Step9